import { render, staticRenderFns } from "./CreateCourses.vue?vue&type=template&id=ae8e630a&scoped=true&"
import script from "./CreateCourses.vue?vue&type=script&lang=js&"
export * from "./CreateCourses.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourses.vue?vue&type=style&index=0&id=ae8e630a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8e630a",
  null
  
)

export default component.exports